import script from "./NewCustomerHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCustomerHistory.vue?vue&type=script&setup=true&lang=js"

import "./NewCustomerHistory.vue?vue&type=style&index=0&id=4ecc9b9c&lang=scss&scoped=true"
import "./NewCustomerHistory.vue?vue&type=style&index=1&id=4ecc9b9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecc9b9c"]])

export default __exports__